import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { RedirectService } from '@core/services/redirect.service';
import { ThemeService } from '@core/services/theme.service';
import { AnswerModuleResponse } from '@shared/models/answer-module-response';

@Directive()
export abstract class PagePreviewBaseComponent {
  constructor(
    protected redirectService: RedirectService,
    protected themeService: ThemeService,
  ) {}

  private _response!: AnswerModuleResponse;

  @Input() previewMode?: string;
  @Input()
  set response(value: AnswerModuleResponse) {
    this._response = value;
    if (value.themeId) {
      this.themeService.loadTheme(value.themeId);
    }
    this.onResponseSet(value);
  }
  get response(): AnswerModuleResponse {
    return this._response;
  }
  @Output() responseChange = new EventEmitter<AnswerModuleResponse>();
  allowNavigation = false;

  protected onResponseSet(value: AnswerModuleResponse): void {}

  protected handlePreviewMode(response: AnswerModuleResponse) {
    if (this.previewMode) {
      this.responseChange.emit(response);
    } else {
      this.allowNavigation = true;
      this.redirectService.redirectToView(response);
    }
  }
}
